import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteItem,
  fetchPaginationData,
} from "../../../utils/apiUtils";
import DeleteModel from "../../../Components/DeleteModel";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../Components/Breadcrumb";
import Pagination from "../../../Components/Pagination";
import {
  ActionButton,
  PlusButton,
} from "../../../Components/TableHelper";
import { formatDate } from "../../../utils/constant";
import TableSearch from "../../../Components/TableSearch";
import PerPageSelect from "../../../Components/PerPageSelect";
import { useDebounce } from "../../../hooks/useDebounce";
const Users = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [nextSortOrder, setNextSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const navigator = useNavigate();

  const fetchDataPagination = async (
    page = 1,
    currentSearch = search,
    currentPerPage = perPage,
  ) => {
    const requestData = {
      perPage: currentPerPage,
      pageNo: page,
      search: currentSearch,
    };
    await fetchPaginationData(
      "user/getAllUsers",
      requestData,
      setdata,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextSortOrder,
    );
  };
  useEffect(() => {
    fetchDataPagination(1);
  }, []);

  const debouncedFetch = useDebounce((searchValue) => {
    fetchDataPagination(1, searchValue);
  }, 500);

  const handleSearchChange = (value) => {
    setSearch(value);
    debouncedFetch(value);
  };
  const handlePerPageChange = (value) => {
    setPerPage(value);
    fetchDataPagination(1, search, value);
  };
  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "user/deleteUser",
        deleteItemId?._id,
        fetchDataPagination,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

 
  const handleAdd = () => {
    navigator("/add-users", { state: { sortOrder: nextSortOrder } });
  };
  const handleEditClick = (item) => {
    navigator("/add-users", {
      state: item,
    });
  };

  const Tableheader = [
    "Full Name",
    "Email",
    "Permissions",
    "Last Updated",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Users", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">Users</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <PerPageSelect value={perPage} onChange={handlePerPageChange} />
          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <TableSearch
              value={search}
              onChange={handleSearchChange}
              placeholder="Search By Title..."
            />
            <PlusButton handleAdd={handleAdd} module={"Users"} />
          </div>
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className=" custom-table table table-striped"
                    id="slidertable"
                  >
                    <thead>
                      <tr>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold " key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : data?.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{item.fullName}</td>
                            <td>{item.email}</td>
                            <td>
                              <button
                                type="button"
                                className="count-button1"
                                onClick={() =>
                                  navigator(`/permission/${item._id}`)
                                }
                              >
                                {item.permissionCount || 0}
                              </button>
                            </td>
                            <td>{formatDate(item.updatedAt)}</td>
                            <td>
                              <ActionButton
                                data={item}
                                handleEditClick={handleEditClick}
                                handleDelete={handleDelete}
                                module={"Users"}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="Users"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default Users;
